<template>
  <div class="layout workbench-theme">
    <AppSidebar />

    <div class="main-wrapper">
      <AppHeader />

      <div class="content-body">
        <div class="page-header">
          <div class="page-title">{{ navStore.pageTitle }}</div>
          <div class="page-sub">{{ navStore.pageSub }}</div>
        </div>

        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, provide, watch } from "vue";
import { useRoute } from "vue-router";
import AppHeader from "@/components/common/AppHeader.vue";
import AppSidebar from "@/components/common/AppSidebar.vue";
import { useNavStore } from "@/stores/useNavStore";

const navStore = useNavStore();
const route = useRoute();

// Sidebar mobile state
const sidebarOpen = ref(false);
const toggleSidebar = () => { sidebarOpen.value = !sidebarOpen.value; };
const closeSidebar = () => { sidebarOpen.value = false; };

provide("sidebarOpen", sidebarOpen);
provide("toggleSidebar", toggleSidebar);
provide("closeSidebar", closeSidebar);

watch(
  () => route.path,
  () => {
    navStore.syncFromRoute(route);
  },
  { immediate: true }
);
</script>
